import Delta from 'quill-delta';

const setupClipboard = (quillInstance) => {
  // Handle direct image matches
  quillInstance.clipboard.addMatcher('IMG', (node, delta) => {
    return new Delta();
  });

  // Handle images within other elements
  quillInstance.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
    const ops = [];

    // Process each operation in the delta
    delta.ops.forEach((op) => {
      // Only keep text insertions
      if (op.insert && typeof op.insert === 'string') {
        ops.push({
          insert: op.insert
        });
      }
      // Explicitly skip image insertions
      else if (op.insert && typeof op.insert === 'object' && op.insert.image) {
        // Skip the image operation
        return;
      }
    });

    // Create new delta with filtered operations
    const newDelta = new Delta();
    newDelta.ops = ops;
    return newDelta;
  });

  // Additional safety: Handle paste event directly
  quillInstance.container.addEventListener('paste', (e) => {
    const clipboardData = e.clipboardData;

    // Check if clipboard contains images
    if (clipboardData.types.includes('Files') ||
      Array.from(clipboardData.items).some(item => item.type.startsWith('image/'))) {
      e.preventDefault();

      // Extract and paste only text content if available
      const text = clipboardData.getData('text/plain');
      if (text) {
        quillInstance.insertText(quillInstance.getSelection()?.index || 0, text);
      }
    }

    // Trigger blur and focus to force magic-url to parse
    setTimeout(() => {
      quillInstance.root.blur();
      quillInstance.root.focus();
    }, 0);
  }, true);
};

export default setupClipboard;
